import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector } from '@/store/PopupStore'
import React, { useEffect } from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import Header from '../Header'
import Nav from '../Nav'
import LoginPopup from '../popup/LoginPopup'
import PayPopup from '../popup/PayPopup'
import RegisterPopup from '../popup/RegisterPopup'
import ResetPasswordPopup from '../popup/ResetPasswordPopup'
import SharePopup from '../popup/SharePopup'
import TopUpDiamondPopup from '../popup/TopUpDiamondPopup'
import TopUpGoldPopup from '../popup/TopUpGoldPopup'
import TradeRecordPopup from '../popup/TradeRecordPopup'

const MainLayout: React.FC<PropType> = () => {
  const menuPopupVisible = useStatePopup(PopupSelector.menuPopupVisible)

  useEffect(() => {
    const timeId = setTimeout(() => {
      // 10秒后统计一次活跃用户
      window.dataKule.push('track', 'user', 'active')
    }, 10000)

    return () => {
      clearTimeout(timeId)
    }
  }, [])

  return (
    <>
      {/* <ScrollToTop /> */}
      <div className="flex flex-col">
        <header className="cus_header fixed left-0 top-0 z-[100] h-14 w-full">
          <Header />
        </header>
        <main className={`h-[1px] min-h-screen pt-14 ${menuPopupVisible ? 'sm:pl-16 2xl:pl-48' : ''}`}>
          <Outlet />
        </main>
      </div>
      <ScrollRestoration />
      <Nav />
      <RegisterPopup />
      <LoginPopup />
      <ResetPasswordPopup />
      <TopUpGoldPopup />
      <TopUpDiamondPopup />
      <TradeRecordPopup />
      <PayPopup />
      <SharePopup />
      <>
        <iframe
          key="1"
          title="1"
          src="https://cdn.j4fgame.com/tool/reset-game-all.html?version=1.0.0"
          style={{ display: 'none' }}
        />
        <iframe
          key="2"
          title="2"
          src="https://cdn1.j4fgame.com/tool/reset-game-all.html?version=1.0.0"
          style={{ display: 'none' }}
        />
        <iframe
          key="3"
          title="3"
          src="https://cdn2.j4fgame.com/tool/reset-game-all.html?version=1.0.0"
          style={{ display: 'none' }}
        />
      </>
    </>
  )
}

interface PropType {}

export default MainLayout
